import Vue from 'vue'
import VueRouter from 'vue-router'

//auth
import Login from "@/views/Auth/Login.vue"
import Register from '@/views/Auth/Register.vue'
import RegisterComplete from '@/views/Auth/RegisterComplete.vue'
//company side
import CompanyDetail from "@/views/CompanyInformation/CompanyDetail.vue"
import CompanyComment from '@/views/CompanyInformation/CompanyComment.vue'
import CompanyDetailUser from '@/views/CompanyInformation/CompanyDetailUser.vue'
import RegisterCardInfor from "../components/templates/CompanyInformation/RegisterCardInfor.vue"
import CheckAmount from "@/views/CheckAmount/CheckAmount.vue"
import SettlementPreview from '../components/templates/CheckAmount/SettlementPreview.vue'
import CompanyJobSearchCreate from '@/views/Recruitment/CompanyJobSearchCreate.vue'
import CompanyJobSearch from '@/views/Recruitment/CompanyJobSearch.vue'
import CompanyJobSearchDetail from '@/views/Recruitment/CompanyJobSearchDetail.vue'
import CompanyJobSaveDraft from '@/views/Recruitment/CompanyJobSaveDraft.vue'
import CompanyCreate from '@/views/CompanyInformation/CompanyCreate.vue'
import CompanyCreateComplete from '@/views/CompanyInformation/CompanyCreateComplete.vue'
//company sub-menu
import CommercialTransactions from "@/components/templates/Menu/SubMenu/CommercialTransactions.vue"
import PrivacyPolicy from "@/components/templates/Menu/SubMenu/PrivacyPolicy.vue"
import PublicRule from "@/components/templates/Menu/SubMenu/PublicRule.vue"
import TermOfUse from "@/components/templates/Menu/SubMenu/TermOfUse.vue"
import AntiSocial from "@/components/templates/Menu/SubMenu/AntiSocial.vue"
// Layout
import NoneMenuLayout from '@/layouts/NoneMenuLayout.vue'
import CommonCompany from '@/layouts/CommonCompany.vue'

Vue.use(VueRouter);
function checkAuth(to: any, from: any, next: any){
  if(window.localStorage.getItem('token')) {
      next(); // allow to enter route
  } else{
      next('/', () =>{}); // go to '/login';
  }
}
const routes: any = [
  {
    path: '/',
    name: "login",
    component: Login
  },
  {
    path: '/company_detail/register',
    name: "register",
    component: Register
  },
  {
    path: '/company_detail/register_complete',
    name: "registerComplete",
    component: RegisterComplete
  },
  {
    path: '/company_detail/create',
    name: 'companyCreate',
    component: CompanyCreate
  },
  {
    path: '/company_detail/create_complete',
    name: 'companyCreateComplete',
    component: CompanyCreateComplete
  },
  {
    path: '/',
    component: NoneMenuLayout,
    children: [
      {
        path: "/company_detail/info",
        name: "registerCardInfor",
        beforeEnter: checkAuth,
        component: RegisterCardInfor
      },
      {
        path: "/company_payment/settlement_preview/month/:id",
        name: "settlementPreview",
        beforeEnter: checkAuth,
        component: SettlementPreview
      },
    ]
  },
  {
    path: '/',
    component: CommonCompany,
    children: [
      //company
      {
        path: "/company_detail",
        name: "companyDetail",
        beforeEnter: checkAuth,
        component: CompanyDetail,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/company_detail/user/customer_id/:id/job_application_id/:index/common_id/:index2",
        beforeEnter: checkAuth,
        name: "companyDetailUser",
        component: CompanyDetailUser
      },
      {
        path: "/company_detail/comment/customer_id/:id",
        name: "companyComment",
        beforeEnter: checkAuth,
        component: CompanyComment
      },
      {
        path: "/company_payment",
        name: "checkAmount",
        beforeEnter: checkAuth,
        component: CheckAmount
      },
      {
        path: "/company_specified_commercial_transaction",
        name: "commercialTransaction",
        beforeEnter: checkAuth,
        component: CommercialTransactions
      },
      {
        path: "/company_privacy_policy",
        name: "privacyPolicy",
        beforeEnter: checkAuth,
        component: PrivacyPolicy
      },
      {
        path: "/company_antisocial",
        name: "antiSocial",
        beforeEnter: checkAuth,
        component: AntiSocial
      },
      {
        path: "/company_policy",
        name: "termOfUse",
        beforeEnter: checkAuth,
        component: TermOfUse
      },
      {
        path: "/company_publication_rules",
        name: "publicRule",
        beforeEnter: checkAuth,
        component: PublicRule
      },
      {
        path: "/company_offer/detail",
        name: "companyJobSearchCreate",
        beforeEnter: checkAuth,
        component: CompanyJobSearchCreate
      },
      {
        path: "/company_offer",
        name: "companyJobsearch",
        beforeEnter: checkAuth,
        component: CompanyJobSearch
      },
      {
        path: "/company_offer/job_information/:id/recruitment/:index",
        name: "companyJobSearchDetail",
        beforeEnter: checkAuth,
        component: CompanyJobSearchDetail
      },
      {
        path: "/company_offer/job_information/:id/recruitment/:index/work_start_date/:index",
        name: "companyJobSearchDetail",
        beforeEnter: checkAuth,
        component: CompanyJobSearchDetail
      },
      {
        path: "/company_offer/draft",
        name: "companyJobSaveDraft",
        beforeEnter: checkAuth,
        component: CompanyJobSaveDraft
      },
    ]
  },
]
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash, offset: { x: 0, y: 120 } };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes
});

export default router
